import React from 'react';
import {Route, Routes} from 'react-router-dom';
import HomePage from "./components/home/homePage";
import {MobileMenuProvider} from "./services/context/mobile-menu-context";
import ProductWrapper from "./components/product/productWrapper";
import ContactMain from "./components/contact/v2/main/contact-main";
import Details from "./components/product/v2/details/details";
import Contact from "./v2/pages/contact/Contact";


const RoutesComponent = () => {

    return (
        <MobileMenuProvider>
            <Routes>
                {/*<Route path="/" element={<HomePage />} />*/}
                <Route path="/" element={<HomePage/>}/>
                {/*<Route path="/fish/:categoryName" element={<CategoryPageWrapper />} />*/}
                {/*<Route path="/corals/:categoryName/:subCategoryName" element={<CoralsCategoryWrapper />} />*/}
                <Route
                    path="/:productGroup/:categoryName"
                    element={<ProductWrapper />}
                />
                <Route
                    path="/:productGroup/:categoryName/:subName"
                    element={<ProductWrapper />}
                />
                <Route
                    path="/:productGroup"
                    element={<ProductWrapper />}
                />
                {/*<Route*/}
                {/*    path="/contact"*/}
                {/*    element={<ContactMain/>}*/}
                {/*/>*/}
                <Route path="/details/:productName" element={<Details />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>

        </MobileMenuProvider>
    );
};

export default RoutesComponent;
